// ===========================================
// Layout Component - Main App Shell
// ===========================================

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AIChat from './AIChat';
import './Layout.scss';

const Layout = () => {
  // Desktop sidebar collapse state
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Mobile sidebar visibility state (separate from desktop collapse)
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  // Toggle desktop sidebar collapse
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Toggle mobile sidebar visibility
  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  // Close mobile sidebar (for nav link clicks and backdrop)
  const closeMobileSidebar = () => {
    setMobileSidebarOpen(false);
  };

  return (
    <div className={`layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Sidebar Navigation */}
      <Sidebar 
        collapsed={sidebarCollapsed} 
        onToggle={toggleSidebar}
        mobileOpen={mobileSidebarOpen}
        onMobileClose={closeMobileSidebar}
      />
      
      {/* Mobile backdrop overlay - closes sidebar when clicked */}
      {mobileSidebarOpen && (
        <div className="layout__backdrop" onClick={closeMobileSidebar} />
      )}
      
      {/* Main Content Area */}
      <div className="layout__main">
        {/* Header - menu button toggles mobile sidebar */}
        <Header onMenuClick={toggleMobileSidebar} />
        
        {/* Page Content */}
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
      
      {/* AI Chat Assistant - Available on all pages */}
      <AIChat />
    </div>
  );
};

export default Layout;

